import { postCustomer } from "src/shared/services/servicesv2";
import api from "../../../../../features/auth/axiosConfig";

interface AddCustomerPayload {
  firstName: string;
  middleName?: string;
  lastName?: string;
  phones: {
    phone: string;
    isPrimary?: boolean;
  }[];
}

/** ✅ ADD CUSTOMER (FIXED) */
export const addCustomer = async (payload: AddCustomerPayload) => {
  if (!payload.firstName?.trim() || !payload.phones?.length) {
    throw new Error("First name and at least one phone number are required");
  }

  // 🔥 Convert phone objects → string array
  const apiPayload = {
    firstName: payload.firstName.trim(),
    middleName: "",
    lastName: "",
    phones: payload.phones.map(p => p.phone),
  };

  const { data } = await postCustomer(apiPayload);
  return data;
};

/** ✅ FETCH OUTSTANDING BALANCE */
export const fetchOutstandingBalance = async (
  customerId: string
): Promise<number> => {
  const { data } = await api.get(
    `/app/pos/v2/customer/${customerId}/balance`
  );
  return Number(data?.balance ?? 0);
};
